import React from 'react';
import './goalsPage.scss';
import {Helmet} from 'react-helmet';

/**
 * The GoalsPage component.
 *
 * @constructor
 */
export class GoalsPage extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {

    return (
      <div id="goals-page" className="system-page">
        <div className="container">
          <Helmet>
            <title>National Excavator Initiative Goals - NEI</title>
            <meta name = "description" content ="The goal of the National Excavator Initiative is to raise the awareness of underground infrastructure and Increase the use of the 811 system." />
          </Helmet>
          <div className="row">
            <div className="col">
              <p>The goal of the National Excavator Initiative is to present a broad-based damage prevention effort that:</p>
              <ul>
                <li><p>Raises the awareness of underground infrastructure</p></li>
                <li><p>Increases the use of the 811 system</p></li>
                <li><p>Encourages stakeholders to take additional safety steps after the 811 call is made in order to protect themselves and the infrastructure</p></li>
              </ul>
              <p className="last">The Initiative will provide meaningful information regarding underground damage prevention, underground facility awareness, and safety messages designed to drive continued awareness and increased safety for those who are, or might be, impacted by damage to underground facilities.</p>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <h1>Join Us!</h1>
              <p>We are seeking support from pipeline companies, utilities, 811 call centers, locators, equipment manufacturers and suppliers, contractors and others who support the damage prevention community – anyone with an interest in safe digging.</p>
              <p>To learn more about the National Excavator Initiative, or to become a supporter, contact:</p>
              <p><a href="mailto:Info@SafeExcavator.com">Info@SafeExcavator.com</a></p>
              <p className="ultimate">Already participating? – Let others in the industry know: pipeline companies, utilities, 811 call centers, locators, contractors, equipment manufacturers and suppliers – in other words, anyone with an interest in safe digging.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

GoalsPage.propTypes = {};

export default GoalsPage;



// WEBPACK FOOTER //
// ./src/components/pages/goals/GoalsPage.js